import { ManuteRequestConfig } from '@/api/types';
import { VacationRequest, VacationQueryParams, VacationExcelQueryParams } from '@/api/requests/vacation/types';

/**
 * Request to find all vacations.
 * @param params
 */
export const ALL = (params?: VacationQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/vacations',
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to save a new vacation.
 * @param data
 */
export const STORE = (data: VacationRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/vacations',
    data,
});

/**
 * Request to find an vacation by id.
 * @param vacationId
 */
export const FIND = (vacationId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/vacations/${vacationId}`,
});

/**
 * Request to update an existing vacation.
 * @param vacationId
 * @param data
 */
export const UPDATE = (vacationId: number, data: VacationRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/vacations/${vacationId}`,
    data,
});

/**
 * Request to update an existing vacation.
 * @param vacationId
 * @param data
 */
export const UPDATE_STATUS = (vacationId: number, status: string): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/vacations/${vacationId}/status`,
    data: {
        status: status,
    }
});

/**
 * Request to delete an vacation by id.
 * @param vacationId
 */
export const DELETE = (vacationId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/vacations/${vacationId}`,
});

/**
 * Request to delete an vacation by id.
 * @param vacationId
 */
export const DURATION = (params?: VacationQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/vacations/duration',
    params: params
});

/**
 * Request to delete an vacation by id.
 * @param vacationId
 */
export const EXCEL = (params?: VacationExcelQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/vacations/excel',
    params: params,
    responseType: 'blob'
});

